import React from "react";
import { Slider, Typography, Box } from "@mui/material";

const AgeRangeSlider = ({ ageRange, setAgeRange }) => {
  // ageRange is an array [min, max], default [0, 88]

  const handleChange = (event, newValue) => {
    setAgeRange(newValue);
  };

  return (
    <Box sx={{ width: 370, px: 2,  }}>
      {/* <Typography gutterBottom>Age Range</Typography> */}
      <Slider
      sx={{color:'#0fb7a4'}}

        getAriaLabel={() => "Age range"}
        value={ageRange}
        onChange={handleChange}
        valueLabelDisplay="auto"
        min={0}
        max={100}
        step={1}
        disableSwap
      />
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="body2">{ageRange[0]}</Typography>
        <Typography variant="body2">{ageRange[1]}</Typography>
      </Box>
    </Box>
  );
};

export default AgeRangeSlider;
